import React from 'react';
import { Breadcrumb } from 'antd';
import type { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';
import { BreadcrumbConfig } from '../../../constants/clients/template-config.interface';

interface DynamicBreadcrumbsProps {
  formData: any;
  config: BreadcrumbConfig;
  separator?: React.ReactNode;
}

export const DynamicBreadcrumbs: React.FC<DynamicBreadcrumbsProps> = ({ formData, config, separator }) => {
  const { fontSize } = useResponsiveSizes();

  const breadcrumbItems = React.useMemo((): BreadcrumbItemType[] => {
    return config.fields
      .filter(field => {
        const value = formData[field];
        // Filtrar campos vacíos o sin valor
        if (value === undefined || value === null || value === '') return false;
        // Filtrar switches en "no"
        if (value === 'no' || value === false) return false;
        return true;
      })
      .map(field => {
        const value = formData[field];
        const formatter = config.formatters?.[field];

        // Formatear el valor si hay formatter
        const displayValue = formatter ? formatter(value) : value;

        return {
          title: `${displayValue}`
        };
      });
  }, [formData, config]);

  // Si no hay items, no mostrar nada
  if (breadcrumbItems.length === 0) return null;

  return (
    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Breadcrumb
        items={breadcrumbItems}
        separator={separator}
        style={{
          fontSize: fontSize.base,
          fontWeight: 500,
          cursor: 'default'
        }}
      />
    </div>
  );
};
